import React from "react";
import T from "prop-types";
import { generate } from "shortid";

const messageMap = message => {
  if (message === "Purchased at Required") {
    return "Date of Price (DOP) Required";
  }
  return message.replace("srp", "SRP");
};

export default function Errors({ errors }) {
  if (errors && errors.length > 0) {
    return (
      <div className="alert alert-danger text-left">
        <p style={{ fontWeight: "bold" }}>
          One or more errors were encountered:
        </p>
        <ul>{errors.map(e => <li key={generate()}>{messageMap(e)}</li>)}</ul>
      </div>
    );
  }

  return null;
}

Errors.propTypes = {
  errors: T.arrayOf(T.string)
};

Errors.defaultProps = {
  errors: {}
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Forms/Errors.jsx